import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import SEO from './SEO';

export const PolicyPage = ({ title, sourceUrl, metaTitle, metaDescription }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(
          //`${apiUrl}/api/proxy?url=${encodeURIComponent(sourceUrl)}`
          `proxy.php?url=${encodeURIComponent(sourceUrl)}`
        );

        if (!response.ok) throw new Error('Failed to fetch content');

        const html = await response.text();
        setContent(html);
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [sourceUrl]);

  return (
    <main data-testid="policy-page" className="pt-24 min-h-screen bg-white">
      <SEO title={metaTitle || title} description={metaDescription || `${title} - Golden Tree Events Dubai. Read our official ${title.toLowerCase()} for event registrations, awards, and services.`} />
      {/* Page Header */}
      <section className="py-12 bg-[#0a0a0a] border-b border-white/10">
        <div className="w-full px-4 sm:px-8 lg:px-16">
          <div className="text-center">
            <h1 className="font-montserrat text-3xl sm:text-4xl lg:text-5xl text-white">
              {title}
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-8xl mx-auto">
          {loading && (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" />
              <span className="ml-3 text-gray-600">Loading content...</span>
            </div>
          )}

          {error && (
            <div className="text-center py-20">
              <p className="text-red-500 text-lg">Failed to load content. Please try again later.</p>
            </div>
          )}

          {!loading && !error && (
            <div 
              className="policy-content prose prose-lg max-w-none text-gray-800"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </section>
    </main>
  );
};

export default PolicyPage;
